<template>
  <div class="statistics">
    <div class="columns">
      <div class="column is-3" style="text-align:center;">
        <Datepicker/>
      </div>
      <div class="column">
        <h1 class="title is-4" style="text-align:center;">{{month_path}}月のデータ</h1>
        <article class="message is-info">
          <div class="message-body">
            <p class="title is-5">今月の総文字数 {{lengthSum}}文字</p>
            <p class="title is-5">今月の書いた日数 {{write_count}}日</p>
          </div>
        </article>
        <h2 style="font-size:1.4em;font-weight:bold;padding-top:30px;text-align:center;">文字数</h2>
        <p style="font-size:.8em;text-align:center;">あなたの書いた日々の日記の文字数をグラフにしたものです。</p>
          <BarChartLength/>
        <h2 style="font-size:1.3em;font-weight:bold;padding-top:30px;text-align:center;">感情スコア</h2>
                <p style="font-size:.8em;text-align:center;">AIにより、あなたが書いた日記のポジティブ度をスコア化したものです。（スコアは-100から100まで）</p>
                <p style="font-size:.8em;text-align:center;">0が平均です。もしマイナスの数字が多かったり、グラフの起伏が激しくなった場合（スコアが-60の次の日に+40になるなど）は感情の振れ幅が大きくなっているので、息抜きをするなど気分転換をしましょう。</p>
          <BarChartSentimentScore />
        <h2 style="font-size:1.4em;font-weight:bold;padding-top:30px;padding-bottom:30px;text-align:center;">あなたの感情の分布</h2>
        <p style="font-size:.8em;text-align:center;">日記中に使われた感情に関する言葉を収集し、「喜怒哀楽」の感情ごとに分類しています（データがない場合は表示されません）</p>
        <p style="font-size:.8em;text-align:center;">意識せずに「哀」が増えてきている場合は、自分で気づかないうちにネガティブな感情になっていますので、注意が必要です。</p>   
            <PieChartEmotionMonth/>
        <!-- <h2 style="font-size:1.3em;font-weight:bold;padding-top:30px;text-align:center;">感情の振れ幅</h2>
          <BarChartSentimentMagnitude /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from '@/components/Datepicker.vue'
import BarChartLength from '@/components/barCharts/BarChartLength.vue'
import BarChartSentimentScore from '@/components/barCharts/BarChartSentimentScore.vue'
// import BarChartSentimentMagnitude from '@/components/barCharts/BarChartSentimentMagnitude.vue'
import PieChartEmotionMonth from '@/components/pieChart/PieChartEmotionMonth.vue'
import firebase from '@firebase/app'
export default {
  components: {
    Datepicker,
    BarChartLength,
    BarChartSentimentScore,
    // BarChartSentimentMagnitude,
    PieChartEmotionMonth
    
  },
  data(){
    return{
      year_path: '',
      month_path:'',
      writeDay: [],
      lengthSum: 0,
      write_count: 0,
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    }
  },
  mounted(){
    const title = "月次データ｜エモーションダイアリー"
    const description = "月次データ画面"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  }, 
  created(){
    var [ , , year_path, month_path] = location.pathname.split('/')
    this.year_path = year_path
    this.month_path = month_path

    firebase.firestore().collection('diary_text').doc(this.user.uid).collection(year_path + '_' + month_path).get().then(snapshot => {
      snapshot.forEach(doc => {
      var data = doc.data()
      var length = data.length
      this.lengthSum += length //今月の総文字数
      this.write_count += 1    //今月の書いた日数
      })
    })
  },
}
</script>

<style scoped>
.statistics{
  padding:10px;
}
</style>